import React from 'react';
import QuestionsAndAnswers, { QuestionsAndAnswersProps } from '../containers/QuestionsAndAnswers';

const QuestionsAndAnswersSection = (props: QuestionsAndAnswersProps) => (
  <QuestionsAndAnswers {...props} />
);

export default QuestionsAndAnswersSection;
